/* eslint react/no-multi-comp: 0, no-unused-vars: 0 */

import React from 'react';
import { i18nData } from 'helpers/i18n';
import { Section, preloader } from 'spectacle-ppa';

import balloonSlide from '../../baseSlides/balloonSlide';
import headingSlide from '../../baseSlides/headingSlide';
import videoSlide from '../../baseSlides/videoSlide';

import imageGameshowTitle_en from './title_gameshow.png';
import imageGameshowTitle_fr_CA from './title_gameshow.fr_CA.png';
import imageGameshowPlayers_en from './title_gameshow_players.png';
import imageGameshowPlayers_fr_CA from './title_gameshow_players.fr_CA.png';

import apprenticesPairArmsFolded from '../../images/characters/apprenticesPairArmsFolded.png';
import apprenticePointingUp2 from '../../images/characters/apprenticePointingUp2.png';
import apprenticePointingUp3 from '../../images/characters/apprenticePointingUp3.png';
import apprenticesFlexArms from '../../images/characters/apprenticesFlexArms.png';
import apprenticeFistUp from '../../images/characters/apprenticeFistUp.png';
import apprenticeHandsHips2 from '../../images/characters/apprenticeHandsHips2.png';
import apprenticeCurious from '../../images/characters/apprenticeCurious.png';
import apprenticePointingDiagonal from '../../images/characters/apprenticePointingDiagonal.png';
import saraSurprised from '../../images/characters/sara_surprised.png';
import ianShrugLaugh from '../../images/characters/ian_shrug_laugh.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFileLevel1_en from './level1_oneWater.md';
import markdownFileLevel1_fr_CA from './level1_oneWater.fr_CA.md';
import markdownFileLevel2_en from './level2_saveWater.md';
import markdownFileLevel2_fr_CA from './level2_saveWater.fr_CA.md';
import markdownFileLevel3_en from './level3_protectWater.md';
import markdownFileLevel3_fr_CA from './level3_protectWater.fr_CA.md';
import markdownFileLevel4_en from './level4_connectInPlace.md';
import markdownFileLevel4_fr_CA from './level4_connectInPlace.fr_CA.md';

const imageGameshowTitle = i18nData({
  en: imageGameshowTitle_en,
  fr_CA: imageGameshowTitle_fr_CA
});

const imageGameshowPlayers = i18nData({
  en: imageGameshowPlayers_en,
  fr_CA: imageGameshowPlayers_fr_CA
});

const markdownFileLevel1 = i18nData({
  en: new MarkdownScript(markdownFileLevel1_en),
  fr_CA: new MarkdownScript(markdownFileLevel1_fr_CA)
});
const markdownFileLevel2 = i18nData({
  en: new MarkdownScript(markdownFileLevel2_en),
  fr_CA: new MarkdownScript(markdownFileLevel2_fr_CA)
});
const markdownFileLevel3 = i18nData({
  en: new MarkdownScript(markdownFileLevel3_en),
  fr_CA: new MarkdownScript(markdownFileLevel3_fr_CA)
});
const markdownFileLevel4 = i18nData({
  en: new MarkdownScript(markdownFileLevel4_en),
  fr_CA: new MarkdownScript(markdownFileLevel4_fr_CA)
});

const levels = {
  '1': { md: markdownFileLevel1 },
  '2': { md: markdownFileLevel2 },
  '3': { md: markdownFileLevel3 },
  '4': { md: markdownFileLevel4 }
};

export function preloadGameShow () {
  preloader([
    imageGameshowTitle_en,
    imageGameshowTitle_fr_CA,
    imageGameshowPlayers_en,
    imageGameshowPlayers_fr_CA,
    apprenticesPairArmsFolded,
    apprenticePointingUp2,
    apprenticesFlexArms,
    apprenticePointingUp3,
    apprenticeFistUp,
    apprenticeHandsHips2,
    apprenticeCurious,
    saraSurprised,
    ianShrugLaugh
  ]);
}

function intro (level, regionData, md) {
  return videoSlide({
    id: 'intro',
    notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
    youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
  });
}

function sizzle (level, regionData, md, i18n) {
  return headingSlide({
    id: 'sizzle',
    bgColor: '#742CBF',
    afterImage: i18n(imageGameshowTitle),
    notes: md.getSubSectionAsHtml('Sizzle', 'Notes', false, regionData)
  });
}

function scoring (level, regionData, md) {
  return balloonSlide({
    id: 'scoring',
    characterSide: 'right',
    characterImage: apprenticeHandsHips2,
    notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData),
    html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData),
    bgColor: '#742CBF'
  });
}

function questionSlide ({
    level,
    questionNumber,
    numQuestions,
    md,
    questionCharacterImage,
    answerCharacterImage,
    regionData,
    i18n}) {
  const _ = i18n;
  const questionSection = `Question ${questionNumber}`;
  const defaultRegion = md.getSectionMetadata(questionSection, 'Default Region', regionData);
  const questionCharacter = !questionCharacterImage ? apprenticeCurious : questionCharacterImage;
  const answerCharacter = !answerCharacterImage ? apprenticePointingUp3 : answerCharacterImage;
  let answer;
  if (defaultRegion) {
    answer = md.getSubSectionAsHtml(questionSection, `Answer - ${defaultRegion}`, false, regionData);
  } else {
    answer = md.getSubSectionAsHtml(questionSection, 'Answer', false, regionData);
  }
  const answerNotes = md.getSubSectionAsHtml(questionSection, 'Answer Notes', false, regionData);

  return [

    // four players announcement
    headingSlide({
      id: `${questionNumber}-four-players`,
      afterImage: i18n(imageGameshowPlayers),
      bgColor: 'black',
      notes: '<h2>' + _`Question ${questionNumber} of ${numQuestions}` + ':</h2>' +
        md.getSubSectionAsHtml(
          'Four Players Announcement',
          'Notes',
          false, regionData
        )
    }),

    // additional slide for level 1, question 2
    (level === 1 && questionNumber === 2 || level === 3 && questionNumber === 4)
    ? balloonSlide({
      balloonType: `question`,
      characterSide: `left`,
      characterImage: apprenticeCurious,
      questionNumber,
      numQuestions,
      id: `${questionNumber}-multiple-choice`,
      html: md.getSubSectionAsHtml(questionSection, 'Question Intro', false, regionData),
      notes: '<h2>' + _`Question ${questionNumber} of ${numQuestions}` + ':</h2>' +
        `<br />` +
        `<p style="font color: white">${_('Multiple choice, see next slide')}</h4>`,
      bgColor: '#45B3EC',
      i18n
    })
    : null,

    // question text
    balloonSlide({
      balloonType: `question`,
      characterSide: `left`,
      characterImage: questionCharacter,
      questionNumber,
      numQuestions,
      id: `${questionNumber}-question`,
      html: md.getSubSectionAsHtml(questionSection, 'Question', false, regionData),
      notes: '<h2>' + _`Question ${questionNumber} of ${numQuestions}` + ':</h2>' +
        `<br />` +
        `<p style="font color: white">${_('Preview of next slide/answer')}</h4>` +
        answer,
      i18n
    }),

    // answer text
    balloonSlide({
      balloonType: `answer`,
      characterSide: `right`,
      characterImage: answerCharacter,
      questionNumber,
      id: `${questionNumber}-answer`,
      html: answer,
      notes: '<h2>' + _`Answer ${questionNumber} of ${numQuestions}` + '</h2>' +
         `<br />` +
         ( !answerNotes.match(/SKIP/) ?
           md.getSubSectionAsHtml(questionSection, 'Answer Notes', false, regionData)
           : ''
         ),
      i18n
    })
  ];
}

function endOfGameShow (level, /*i18n*/_) {
  return balloonSlide({
    id: 'end',
    characterSide: 'left',
    characterImage: apprenticeFistUp,
    bgColor: '#742CBF',
    html: '<h3>' + _`Level ${level} game show completed` + '!</h3>',
    notes: _('Game show completed') + '.'
  });
}

function level1 (regionData, i18n) {
  const level = 1;
  const md = i18n(levels[level].md);

  return (
    <Section id="game-show">

      {/* Sizzle */}
      {sizzle(level, regionData, md, i18n)}

      {/* Sara and Ian introduce the Game Show */}
      {intro(level, regionData, md)}

      {/* Scoring intro */}
      {scoring(level, regionData, md)}

      {/* Game show questions */}
      {questionSlide({ level, questionNumber: 1, numQuestions: 3, md, regionData, i18n })}

      {/* Scoring reminder */}
      {balloonSlide({
        id: 'scoring-reminder',
        characterSide: 'right',
        characterImage: apprenticePointingDiagonal,
        notes: md.getSubSectionAsHtml('Scoring Reminder', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Scoring Reminder', 'Content', false, regionData),
        bgColor: '#742CBF'
      })}

      {questionSlide({ level, questionNumber: 2, numQuestions: 3, md, regionData, i18n })}
      {questionSlide({ level, questionNumber: 3, numQuestions: 3, md, regionData, i18n })}

      {/* End of Game Show */}
      {endOfGameShow(level, i18n)}

    </Section>
  );
}

function level2 (regionData, i18n) {
  const level = 2;
  const md = i18n(levels[level].md);

  return (
    <Section id="game-show">

      {/* Sizzle */}
      {sizzle(level, regionData, md, i18n)}

      {/* Sara and Ian introduce the Game Show */}
      {intro(level, regionData, md)}

      {/* Scoring intro */}
      {scoring(level, regionData, md)}

      {/* Game show questions */}
      {questionSlide({ level, questionNumber: 1, numQuestions: 3, md, regionData, i18n })}

      {/* Scoring reminder */}
      {balloonSlide({
        id: 'scoring-reminder',
        characterSide: 'right',
        characterImage: apprenticePointingDiagonal,
        notes: md.getSubSectionAsHtml('Scoring Reminder', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Scoring Reminder', 'Content', false, regionData),
        bgColor: '#742CBF'
      })}

      {questionSlide({ level, questionNumber: 2, numQuestions: 3, md, regionData, i18n })}
      {questionSlide({ level, questionNumber: 3, numQuestions: 3, md, regionData, i18n })}

      {/* End of Game Show */}
      {endOfGameShow(level, i18n)}

    </Section>
  );
}

function level3 (regionData, i18n) {
  const level = 3;
  const md = i18n(levels[level].md);

  return (
    <Section id="game-show">

      {/* Sizzle */}
      {sizzle(level, regionData, md, i18n)}

      {/* Sara and Ian introduce the Game Show */}
      {intro(level, regionData, md)}

      {/* Game show questions */}
      {questionSlide({ level, questionNumber: 1, numQuestions: 5, md, regionData, i18n })}
      {questionSlide({ level, questionNumber: 2, numQuestions: 5, md, regionData, i18n })}
      {questionSlide({ level, questionNumber: 3, numQuestions: 5, md, regionData, i18n })}
      {questionSlide({ level, questionNumber: 4, numQuestions: 5, md, regionData, i18n })}
      {questionSlide({ level, questionNumber: 5, numQuestions: 5, md, regionData, i18n })}

      {/* End of Game Show */}
      {endOfGameShow(level, i18n)}

    </Section>
  );
}

function level4 (regionData, i18n) {
  const level = 4;
  const md = i18n(levels[level].md);

  return (
    <Section id="game-show">

      {/* Sizzle */}
      {sizzle(level, regionData, md, i18n)}

      {/* Sara and Ian introduce the Game Show */}
      {intro(level, regionData, md)}

      {/* Game show questions */}
      {questionSlide({ level, questionNumber: 1, numQuestions: 3, md, regionData, i18n })}
      {questionSlide({ level, questionNumber: 2, numQuestions: 3, md, regionData, i18n })}
      {questionSlide({ level, questionNumber: 3, numQuestions: 3, md, regionData, i18n })}

      {/* End of Game Show */}
      {endOfGameShow(level, i18n)}

    </Section>
  );
}

function gameShowSection ({ level, regionData, i18n }) {
  switch (level) {
  case 1:
    return level1(regionData, i18n);
  case 2:
    return level2(regionData, i18n);
  case 3:
    return level3(regionData, i18n);
  case 4:
    return level4(regionData, i18n);
  default:
    return headingSlide({ heading: 'Unknown' });
  }
}

export default gameShowSection;



// WEBPACK FOOTER //
// ./programs/h2whoa/sections/20_gameShow/gameShowSection.jsx